import { useIntl as reactIntlUseIntl } from 'react-intl'

function useIntl () {
  return reactIntlUseIntl()
}

export default useIntl
